import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import GenStack from './GenStack';
import { ScrollTop, PageContainer } from '../shared';
import { Error } from '../pages';

const AppRoutes = () => (
  <BrowserRouter>
    <ScrollTop>
      <PageContainer>
        <Routes>
          {GenStack}
          <Route path="*" element={<Error />} />
        </Routes>
      </PageContainer>
    </ScrollTop>
  </BrowserRouter>
);

export default AppRoutes;
